import { MODAL } from '@/providers/ModalActionProvider';
import type { PopupMenuItemProps } from './PopupMenuItem';
export const menu: PopupMenuItemProps[] = [{
  icon: 'icon-pr-flat-wallet',
  title: 'Wallet',
  modal: MODAL.WALLET
}, {
  icon: 'icon-pr-flat-vip-crown',
  title: 'Vip',
  modal: null
}, {
  icon: 'icon-pr-flat-stats',
  title: 'Stats',
  modal: null
}, {
  icon: 'icon-pr-flat-transaction',
  title: 'Transactions',
  modal: null
}, {
  icon: 'icon-pr-flat-add-user',
  title: 'Refer and Earn',
  modal: null
}, {
  icon: 'icon-pr-flat-user',
  title: 'Account',
  modal: MODAL.KYC
}, {
  icon: 'icon-pr-flat-question-mark',
  title: 'Help center',
  modal: null
}, {
  icon: 'icon-pr-flat-live-support',
  title: 'Live support',
  modal: null
}, {
  icon: 'icon-pr-flat-exit',
  title: 'Logout',
  modal: null
}];